import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsRecentlyVisitedProductsCarousel {
    export const ID = 'recently-visited-products-carousel';

    export interface IComponentData extends NICmsContentComponent.IData {
        category_title: string;
        recently_title: string;
        category_id: number;
        limit: number;
        min_qty_for_recently_viewed: number;
    }

    export enum CarouselType {
        recentlyViewed = 'recentlyViewed',
        category = 'category'
    }
}
